import angular from 'angular';
import _ from 'lodash';

class modalContainerUpdateCtrl {
  /*@ngInject*/
  constructor(logger, PrincipalSvc, Containers, $uibModal) {
    this.PrincipalSvc = PrincipalSvc;
    this.logger = logger;
    this.PrincipalSvc = PrincipalSvc;
    this.Containers = Containers;
    this.$uibModal = $uibModal;
  }

  $onInit() {
    this.containersSelected = angular.copy(this.resolve.containersSelected);
    this.selectedMappingMode = null;
    this.includes = {
      formMessages: require('../../../common/form-messages.html')
    };
    this.containersIds = _.map(this.containersSelected, container => {
      return container.id;
    });
  }

  cancel() {
    this.modalInstance.dismiss('cancel');
  }

  ok() {
    if (
      this.form.$valid &&
      (!this.criteria.treatmentTypeSpecific || (this.criteria.treatmentTypeSpecific && this.isFilenameValid()))
    ) {
      this.updateContainers(false);
    }
  }

  hasModeEpdf() {
    const hasEpdf = _.find(this.containersSelected, container => {
      return container.mode === 'STANDARD';
    });
    return hasEpdf;
  }

  /**
   * Envoi la requete pour mettre à jour le serveur.
   * createRemoteFolders True pour créer le répertoire FTp si nécessaire
   */
  updateContainers(createRemoteFolders) {
    this.criteria.containersSelected = this.containersIds;
    this.criteria.createRemoteFolders = createRemoteFolders;

    this.Containers.updateContainers(this.criteria, this.fileUpload).then(
      () => {
        this.logger.success('Les containers ont été mis à jour');
        this.modalInstance.close();
      },
      error => {
        if (error.data.code === 'NOT_FOUND_001') {
          this.$uibModal
            .open({
              component: 'ModalContainerUpdateConfirm',
              resolve: {
                platformPath: () => {
                  return this.criteria.platformPath;
                }
              },
              backdrop: 'static',
              keyboard: false
            })
            .result.then(this.closeContainerConfirmModal, this.dismissModal);
        } else {
          this.logger.error('error.update');
        }
      }
    );
  }

  closeContainerConfirmModal(createRemoteFolders) {
    if (createRemoteFolders) {
      this.updateContainers(true);
    } else {
      this.cancel();
    }
  }

  dismissModal() {}

  /**
   * Vérifie que le nom du fichier est valide.
   */
  isFilenameValid() {
    var isValid = false;
    if (this.fileUpload && this.fileUpload.filedata) {
      var regex = new RegExp('\\w-\\d+\\.\\d+\\.ftl', 'i');
      isValid = regex.test(this.fileUpload.filedata.name);
    }
    return isValid;
  }
}

angular.module('app.principal').component('modalContainerUpdate', {
  templateUrl: require('./modal-container-update.html'),
  controller: modalContainerUpdateCtrl,
  bindings: {
    modalInstance: '<',
    resolve: '<'
  }
});
